import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { NavigationDataService } from 'app/shared/services/data-services/navigation/navigation-data.service';
import { filter, map } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { UserPreferencesService } from 'app/shared/services-api-central/user-preferences/user-preferences.service';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';

@Injectable()
export class NavigationDataGuard {

  constructor(
    private navigationDataService: NavigationDataService,
    private userPreferences: UserPreferencesService,
    private userProfileService: UserProfileService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    

    return combineLatest([
      this.userPreferences.getUserPreferencesLoaded(),
      this.navigationDataService.getSubPortfolioListData(),
      this.userProfileService.userProfileLoaded()
    ]).pipe(
      filter(([prefsLoaded, navData, profileLoaded]) => !!prefsLoaded && !!navData && !!profileLoaded),
      map(() => true)
    );
  }
}
